module.exports = __webpack_public_path__ + "img/horn.1f862f5e.svg";